import { render, staticRenderFns } from "./GameDisplay.vue?vue&type=template&id=dbf05ac2&"
import script from "./GameDisplay.vue?vue&type=script&lang=js&"
export * from "./GameDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports